module.exports = __webpack_public_path__ + "img/52002759_L.4766a2d1.png";